"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementSaveClientModalComponent = exports.ConnectManagementSaveClientModalComponentContext = void 0;
const core_1 = require("@angular/core");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const angular2_modal_1 = require("angular2-modal");
const connect_client_1 = require("./connect-client");
const _ = require("lodash");
const connect_rtbx_client_1 = require("./connect-rtbx-client");
const forms_1 = require("@angular/forms");
class ConnectManagementSaveClientModalComponentContext extends bootstrap_1.BSModalContext {
}
exports.ConnectManagementSaveClientModalComponentContext = ConnectManagementSaveClientModalComponentContext;
let ConnectManagementSaveClientModalComponent = class ConnectManagementSaveClientModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.context = dialog.context;
        this.client = new connect_client_1.ConnectClient(_.cloneDeep(this.context.client));
    }
    ngOnInit() {
        this.form = new forms_1.FormGroup({
            rtbxId: new forms_1.FormControl("rtbxId"),
            name: new forms_1.FormControl("name"),
        });
    }
    type() {
        this.client.name = null;
    }
    onVerifyRTBXId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            try {
                let rtbxClient = yield connect_rtbx_client_1.ConnectRTBXClient.get(id);
                this.client.setName(rtbxClient.name);
            }
            catch (err) {
                this.error = err;
            }
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            try {
                yield this.client.create();
                this.dialog.close({ saved: true });
            }
            catch (err) {
                if (err.client) {
                    this.existing = err.client;
                    return;
                }
                this.error = err;
            }
        });
    }
    cancelReassignment() {
        return __awaiter(this, void 0, void 0, function* () {
            this.existing = null;
        });
    }
    confirmReassignment() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            let client = new connect_client_1.ConnectClient({
                id: this.existing.id,
                name: this.existing.name,
                organization: this.client.organization,
            });
            try {
                yield client.update();
                this.dialog.close({ saved: true });
            }
            catch (err) {
                this.error = err;
            }
        });
    }
    showForm() {
        return !this.existing;
    }
    showConflict() {
        return !!this.existing;
    }
    saveDisabled() {
        return this.form.invalid;
    }
};
exports.ConnectManagementSaveClientModalComponent = ConnectManagementSaveClientModalComponent;
exports.ConnectManagementSaveClientModalComponent = ConnectManagementSaveClientModalComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management-save-client-modal",
        templateUrl: "app/connect-management-save-client-modal.component.html",
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
], ConnectManagementSaveClientModalComponent);
//# sourceMappingURL=connect-management-save-client-modal.component.js.map